import React, { Fragment, useContext, useEffect, useState } from 'react';
import _uniqueId from 'lodash/uniqueId';
import BiHelp from './BiHelp';
import { SessionContext } from '../../../context/SessionProvider';

import authService from '../../api-authorization/AuthorizeService'
import BiDataGrid from '../dataGrid/BiDataGrid';
import BiLabel from './BiLabel';
import BiButton from './BiButton';
import { httpGet } from '../../helpers/httpHelper';
import yesno from 'yesno-dialog'
import BiComboBox from './BiComboBox';

const BiFileUpload = ({

    idObrazca,
    tipDatoteke,
    tipiDatoteke,
    readOnly,
    mainKey,
    items,

    name,
    style,
    disabled,

    onAdd,
    onRemove,

    skipAuth
}) => {
    const { toastError, setLoading, toastOK } = useContext(SessionContext)

    const [prilogaLoad, setPrilogaLoad] = useState(false);

    const onImageChange = (e) => {
        let nn = e.target.name;


        var velikost = e.target.files[0].size;
        if (velikost > 1024 * 1024 * 20) {
            alert("Datoteka je lahko velika max 20MB");
            return;
        }

        let formData = new FormData();
        formData.append('slika', e.target.files[0]);
        formData.append('idObrazca', idObrazca);
        if (tipiDatoteke != null) {

            formData.append('tipDatoteke', tip.id);
        } else {
            formData.append('tipDatoteke', tipDatoteke);
        }

        setPrilogaLoad(true)

        if (skipAuth) {
            fetch("api/Prijava/UploadFile", {
                method: 'POST',
                body: formData,
            })
                .then(response => {
                    return response.json();
                })
                .then(response => {
                    console.log(response)
                    if (response.success) {
                        if (onAdd != null) {
                            onAdd(response.datoteka, name);
                        }
                        e.target.value = null;

                    } else {
                        alert(response.message);
                    }

                    setPrilogaLoad(false);
                });

        }
        else {

            const sss = authService.getAccessToken().then(token => {

                fetch("api/Obrazci/UploadFile", {
                    method: 'POST',
                    body: formData,
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                    .then(response => {
                        return response.json();
                    })
                    .then(response => {
                        console.log(response)
                        if (response.success) {
                            if (onAdd != null) {
                                onAdd(response.datoteka, name);
                            }
                            e.target.value = null;

                        } else {
                            alert(response.message);
                        }

                        setPrilogaLoad(false);
                    });
            });
        }
    }


    const gumbPrenesi = (col, item) => {
        return <BiButton icon="fas fa-download " width="90" onClick={() => prenesiPrilogo(item)} >Prenesi</BiButton>
    }
    const prenesiPrilogo = (obrazec) => {
        console.log(obrazec);

        setPrilogaLoad(true);

        if (skipAuth) {
            const requestOptions = {
                method: 'GET',
                responseType: 'blob'
            };

            const params = {
                PIdDatoteke: obrazec.pIdDatoteke
            };
            const url = "api/prijava/GetFile" + "?" + (new URLSearchParams(params)).toString();
            fetch(url, requestOptions)
                .then(response => {
                    return response.json();
                }).then(ret => {
                    console.log(ret);

                    if (ret.success) {

                        fetch('data:' + ret.tip + ';base64,' + ret.datoteka)
                            .then(fileRes => { return fileRes.blob() })
                            .then(fil => {

                                const file = new Blob([fil]);
                                const fileURL = URL.createObjectURL(file, { type: ret.tip });

                                var anchor = document.createElement("a");
                                anchor.download = ret.naziv;
                                anchor.href = fileURL;
                                anchor.click();
                            })
                    }
                    else {
                        alert(ret.message);
                    }

                    setPrilogaLoad(false);
                });
        

        } else {
            const sss = authService.getAccessToken().then(token => {

                const requestOptions = {
                    method: 'GET',
                    responseType: 'blob',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                };

                const params = {
                    PIdDatoteke: obrazec.pIdDatoteke
                };
                const url = "api/obrazci/GetFile" + "?" + (new URLSearchParams(params)).toString();
                fetch(url, requestOptions)
                    .then(response => {
                        return response.json();
                    }).then(ret => {
                        console.log(ret);

                        if (ret.success) {

                            fetch('data:' + ret.tip + ';base64,' + ret.datoteka)
                                .then(fileRes => { return fileRes.blob() })
                                .then(fil => {

                                    const file = new Blob([fil]);
                                    const fileURL = URL.createObjectURL(file, { type: ret.tip });

                                    var anchor = document.createElement("a");
                                    anchor.download = ret.naziv;
                                    anchor.href = fileURL;
                                    anchor.click();
                                })
                        }
                        else {
                            alert(ret.message);
                        }

                        setPrilogaLoad(false);
                    });
            });
        }



    }
    const brisiPrilogo = async (obrazec) => {



        const yes = await yesno({
            labelYes: "Da",
            labelNo: "Ne",
            bodyText: "Ali želite izbrisati datoteko?"
        });

        if (yes == true) {
            setPrilogaLoad(true);
            httpGet(
                skipAuth == true ? "api/prijava/DeleteFile" : "api/obrazci/DeleteFile",
                {
                    PIdDatoteke: selectedDatoteka.pIdDatoteke
                },
                (ret) => {
                    if (ret.success) {
                        console.log(onRemove, ret)
                        if (onRemove != null) {
                            console.log(ret)
                            onRemove(selectedDatoteka.pIdDatoteke, name);
                        }
                        toastOK("Uspešno!");

                    } else {
                        toastError(ret.message);
                    }
                    setPrilogaLoad(false);
                },
                skipAuth == true ? null : authService);
        }
    }

    const [selectedDatoteka, setSelectedDatoteka] = useState(null);
    const onDatotekaSelectionChanged = (e) => {
        setSelectedDatoteka(e);
    }

    const [tip, setTip] = useState(null);
    const onTipChanged = (item) => {
        setTip(item.target.value);
        console.log(item.target.value);
    }


    return (
        <Fragment>
            {readOnly == false &&
                <Fragment>

                    {tipiDatoteke &&
                        <Fragment>
                            <BiLabel style={{ marginRight: "10px" }} icon="fas fa-list">Tip: </BiLabel>
                            <BiComboBox items={tipiDatoteke} name="tipi" item={tip} onItemSelected={onTipChanged} width="200" ></BiComboBox>
                        </Fragment>
                    }
                    {(tipiDatoteke == null) || (tip != null && tip.id != null) &&
                        <Fragment>
                            <BiLabel style={{ marginRight: "10px", marginLeft: "10px" }} icon="fas fa-upload">Datoteka: </BiLabel>
                            <input id={name + "-upload"} name={name} onChange={onImageChange} type="file" disabled={prilogaLoad} />
                        </Fragment>
                    }
                    {prilogaLoad &&
                        <div className="spinner-border text-primary" role="status" style={{
                            position: "relative",
                            float: "right",
                            marginBottom: "0px",
                            marginLeft: "20px",
                            top: "4px",
                            height: "26px",
                            width: "26px",
                            borderWidth: "0.2em",
                            borderColor: "rgb(50, 180, 88)",
                            borderRightColor: "white"
                        }}>
                        </div>
                    }
                    <hr></hr>
                </Fragment>
            }



            <BiDataGrid
                items={items}
                mainKey="pIdDatoteke"
                onSelectionChanged={(e) => onDatotekaSelectionChanged(e)}
                columns={[
                    { label: "ID", key: "pIdDatoteke", type: "decimal", width: "50px" },
                    { label: "Datum vpisa", key: "datumVpisa", type: "date", width: "120px" },
                    { label: "Naziv", key: "naziv", type: "string", width: "300px" },
                    { label: "Tip", key: "tipDatotekeObrazca", type: "string", width: "300px" },
                    { label: "", key: "pIdDatoteke", type: "template", width: "90px", displayFunction: gumbPrenesi, cellStyle: { style: { padding: "0px" } } },
                    { width: "100%" },
                ]}
                toolbar={
                    <Fragment>
                        {readOnly == false &&
                            <BiButton icon="fas fa-trash " disabled={prilogaLoad} onClick={() => brisiPrilogo()} >Briši</BiButton>
                        }
                    </Fragment>
                }
                footer={items == null ?
                    <Fragment>
                        Seznam datotek je prazen.
                    </Fragment>
                    :
                    null

                }

            ></BiDataGrid>

            <br />
        </Fragment>
    );
}

export default BiFileUpload;